import DropDownMenu from 'material-ui/DropDownMenu';

export default class FSDropDownMenu extends DropDownMenu {
}

FSDropDownMenu.defaultProps = {
  style: {
    backgroundColor: '#81A2CA',
    margin: '10px',
    maxHeight: '28px',
    width: '220px',
  },
  labelStyle: {
    lineHeight: '28px',
    fontSize: '.8em',
    textAlign: 'center',
  },
  iconStyle: {
    top: '2px',
  },
  underlineStyle: {
    display: 'none',
  },
  value: 'label',
  maxHeight: 700,
  autoWidth: true,
};



// WEBPACK FOOTER //
// ./src/components/lib/FSDropDownMenu.js